import { actionTag } from "../../../helpers/AuditLogHelper";

// An action's tag: its icon and its text, so the colour is never the only sign.
export const ActionTag = ({ action }) => {
  const { icon, tone } = actionTag(action);
  return (
    <span className={`audit-tag audit-tag-${tone}`}>
      <i className={`pi ${icon}`} aria-hidden="true" />
      {action}
    </span>
  );
};

export default ActionTag;
